import {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router';
import {useSelector} from 'react-redux';
import {isTemplateBlacklistedForAdRefresh} from 'app/components/ads/adHelpers';
import {selectSsrRendered} from 'app/hooks/reduxCreateSelectorHooks';

const useRemountKey = () => {
  const {pathname} = useLocation();
  const isHydrating = useSelector(selectSsrRendered);

  const mountedRef = useRef(false);

  const [key, setKey] = useState(() => (typeof window === 'undefined' || isHydrating ? 999 : Date.now()));

  // Update key on route change
  useEffect(() => {
    if (!mountedRef.current) {
      return;
    }
    const blacklisted = isTemplateBlacklistedForAdRefresh(pathname);
    const isMatchPage = pathname.startsWith('/match/');
    const shouldUpdate = !isMatchPage && !blacklisted;

    if (shouldUpdate) {
      setKey(Date.now());
    }
  }, [pathname]);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return key;
};

export {useRemountKey};
